import { YammerCache } from '@ms/yammer-data/dist/cache';

import { getCachedItem, removeCachedItem, setCachedItem } from './mobileEmbedView';

export default class VivaConnectionsStorage implements YammerCache {
  public getItem<T>(key: string): T | null {
    const cachedDataForKey = getCachedItem(key);

    return cachedDataForKey ? JSON.parse(cachedDataForKey) : null;
  }

  public setItem<T>(key: string, value: T): void {
    const serializedValue = JSON.stringify(value);
    setCachedItem(key, serializedValue);
  }

  public removeItem(key: string): void {
    removeCachedItem(key);
  }

  public clear(): void {
    throw new Error('Method not implemented.');
  }
}
